import { Platform } from 'react-native';
import { gestureHandlerRootHOC } from 'react-native-gesture-handler';

import { useCachedResources, SplashScreen } from '@pletly/ui';
import { initSentry } from '@pletly/feature-sentry';
import { AppProviders } from './app/AppProviders';
import App from './app/App';
import './i18n';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// https://docs.swmansion.com/react-native-gesture-handler/docs/fundamentals/installation#web
initSentry();

export default gestureHandlerRootHOC(function () {
	const isLoadingComplete = useCachedResources();

	if (!isLoadingComplete) {
		return <SplashScreen noImage={Platform.OS === 'web'} />;
	}

	return (
		<AppProviders>
			<App />
		</AppProviders>
	);
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
